// utils/redirect.js
export const redirectUtil = {
    // 保存跳转URL
    saveRedirectUrl() {
        const currentPath = sessionStorage.getItem('route');
        // 排除登录相关页面
        if (currentPath && !currentPath.includes('/login') && !currentPath.includes('/loginJump')) {
            sessionStorage.setItem('redirectUrl', currentPath);
        }
    },

    // 获取跳转URL
    getRedirectUrl() {
        return sessionStorage.getItem('redirectUrl') || '';
    },

    // 清除跳转URL
    clearRedirectUrl() {
        sessionStorage.removeItem('redirectUrl');
    },

    // 执行跳转
    redirectAfterLogin(router) {
        const redirectUrl = this.getRedirectUrl();
        let finalPath = '/home/index';
        this.clearRedirectUrl();
        if (redirectUrl) {
            const routeAllStr = localStorage.getItem('routeAll');
            if (routeAllStr) {
                if (routeAllStr.includes(redirectUrl)) {                    
                    finalPath = redirectUrl;
                }
            }
        }
        router.push({ path: finalPath });
    }
};


// WEBPACK FOOTER //
// ./src/utils/redirect.js